// removed by extract-text-webpack-plugin
module.exports = {"leftItems":"index-module__leftItems___jz2TN"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/graphql/ContactMessage/index.module.scss
// module id = 1889
// module chunks = 146